import { Dropdown, DropdownMenu, DropdownItem } from "reactstrap";
import { useNavigate } from "react-router-dom";

import useFetch from "Hooks/useFetch";
import useHelpers from "Hooks/useHelpers";

export default function ClientHealthContextMenu({
    visible,
    toggle,
    row,
    x,
    y,
}: {
    visible: boolean;
    toggle: () => void;
    row: IMessageHeader;
    x: number;
    y: number;
}) {
    const { post } = useFetch();
    const { handleLoginCompanyOkResponse } = useHelpers();

    const navigate = useNavigate();

    async function goToCompany() {
        const url = `/api/login_company?returnUrl=/run&company_id=${row.company_id}`;

        const response = await post(url);
        const data = await response.json();
        console.log(data);

        if (response.ok) {
            handleLoginCompanyOkResponse(data);
            navigate("/run");
        }
    }

    return (
        <>
            <Dropdown
                isOpen={visible}
                toggle={toggle}
                style={{
                    position: "absolute",
                    zIndex: 100,
                    left: x,
                    top: y,
                }}
            >
                <DropdownMenu>
                    <DropdownItem onClick={goToCompany} target="_blank">
                        Go to Company Log
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </>
    );
}
